import { render, staticRenderFns } from "./PaketSatKer.vue?vue&type=template&id=6b8fa55f&"
import script from "./PaketSatKer.vue?vue&type=script&lang=js&"
export * from "./PaketSatKer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports